import React, { useMemo } from 'react';
import { BuildingStorefrontIcon } from '@heroicons/react/24/outline';

import { Combobox, Label } from '../../../components/ui';
import { BVIndexedBrand } from '../types';

interface BrandSelectorProps {
  value: string;
  onChange: (value: string) => void;
  brands: BVIndexedBrand[];
  disabled?: boolean;
}

export function BrandSelector({ value, onChange, brands, disabled = false }: BrandSelectorProps) {
  const options = useMemo(
    () =>
      brands.map(brand => ({
        value: brand.brand,
        label: brand.brand,
        description: `${brand.count.toLocaleString()} indexed reviews`,
        icon: <BuildingStorefrontIcon className="h-4 w-4 text-gray-400" />,
      })),
    [brands],
  );

  return (
    <div className="space-y-2">
      <Label>Brand</Label>
      <Combobox
        options={options}
        value={value || null}
        onChange={nextValue => onChange(nextValue || '')}
        placeholder={brands.length > 0 ? 'Select an indexed brand' : 'No indexed brands available yet'}
        searchPlaceholder="Search brands..."
        emptyMessage="No matching brand found."
        clearable
        disabled={disabled || brands.length === 0}
      />
      <p className="text-xs text-gray-500 dark:text-gray-400">
        Drafts are based on the reviews currently indexed for the selected brand.
      </p>
    </div>
  );
}

export default BrandSelector;
